import { Get } from "services/apiService";
import { BASE_URL, SOMS_API_KEY } from "services/CONSTANTS";
import {
  GET_CUTOFF_TIME_REQUEST,
  GET_CUTOFF_TIME_SUCCESS,
  GET_CUTOFF_TIME_ERROR,
  CLEAR_CUTOFF_TIME_REQUEST,
} from "redux/actions/action-type";

export const getCutOffTime =
  () =>
  async (dispatch) => {
    const apiUrl = `${BASE_URL}configurations?&apikey=${SOMS_API_KEY}`;
    dispatch({ type: GET_CUTOFF_TIME_REQUEST });
    Get({ url: apiUrl })
      .then((response) => {
        if (response.status === 200)
          dispatch({ type: GET_CUTOFF_TIME_SUCCESS, payload: response.data });
        else
          dispatch({
            type: GET_CUTOFF_TIME_ERROR,
            payload:
              response.data.errorMessage ||
              "Error occurred while fetching records.",
          });
      })
      .catch((error) => {
        dispatch({
          type: GET_CUTOFF_TIME_ERROR,
          payload: error.message || "Error occurred while fetching records.",
        });
      });
  };

export const clearCutOffTime = () => async (dispatch) => {
  dispatch({ type: CLEAR_CUTOFF_TIME_REQUEST });
};
